var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.457 26.5C30.457 26.1548 30.1772 25.875 29.832 25.875H26.4987C26.1535 25.875 25.8737 26.1548 25.8737 26.5V29.8333C25.8737 30.1785 26.1535 30.4583 26.4987 30.4583C26.8439 30.4583 27.1237 30.1785 27.1237 29.8333V28.0089L30.2234 31.1086C30.4675 31.3527 30.8632 31.3527 31.1073 31.1086C31.3514 30.8645 31.3514 30.4688 31.1073 30.2247L28.0076 27.125H29.832C30.1772 27.125 30.457 26.8452 30.457 26.5Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5404 26.5C17.5404 26.1548 17.8202 25.875 18.1654 25.875H21.4987C21.8439 25.875 22.1237 26.1548 22.1237 26.5V29.8333C22.1237 30.1785 21.8439 30.4583 21.4987 30.4583C21.1535 30.4583 20.8737 30.1785 20.8737 29.8333V28.0089L17.774 31.1086C17.5299 31.3527 17.1342 31.3527 16.8901 31.1086C16.646 30.8645 16.646 30.4688 16.8901 30.2247L19.9898 27.125H18.1654C17.8202 27.125 17.5404 26.8452 17.5404 26.5Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.457 21.5C30.457 21.8452 30.1772 22.125 29.832 22.125H26.4987C26.1535 22.125 25.8737 21.8452 25.8737 21.5V18.1667C25.8737 17.8215 26.1535 17.5417 26.4987 17.5417C26.8439 17.5417 27.1237 17.8215 27.1237 18.1667V19.9911L30.2234 16.8914C30.4675 16.6473 30.8632 16.6473 31.1073 16.8914C31.3514 17.1355 31.3514 17.5312 31.1073 17.7753L28.0076 20.875H29.832C30.1772 20.875 30.457 21.1548 30.457 21.5Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5404 21.5C17.5404 21.8452 17.8202 22.125 18.1654 22.125H21.4987C21.8439 22.125 22.1237 21.8452 22.1237 21.5V18.1667C22.1237 17.8215 21.8439 17.5417 21.4987 17.5417C21.1535 17.5417 20.8737 17.8215 20.8737 18.1667V19.9911L17.774 16.8914C17.5299 16.6473 17.1342 16.6473 16.8901 16.8914C16.646 17.1355 16.646 17.5312 16.8901 17.7753L19.9898 20.875H18.1654C17.8202 20.875 17.5404 21.1548 17.5404 21.5Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaps);
export default __webpack_public_path__ + "static/media/collaps.c701175799ea6c4a23e3e4ef11f0da79.svg";
export { ForwardRef as ReactComponent };